import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { PinnedSectionDefaults } from "../base";
import type { AnimationActions, ScrollTriggerProps } from "../types";

const enterProps = { top: "0", duration: 1 };

const animation: AnimationActions = {
  onEnter: ({ section }) => {
    gsap.timeline().to(section, enterProps);
  },
  onEnterBack: ({ section }) => {
    gsap.timeline().to(section, enterProps);
  },
  onLeave: ({ section }) => {
    const props = { top: "-100dvh", duration: 1 };
    gsap.timeline().to(section, props);
  },
  onLeaveBack: ({ section }) => {
    const props = { top: "100dvh", duration: 1 };
    gsap.timeline().to(section, props);
  },
};

const getViewportHeight = () => window.innerHeight;

const getStepRange = (step: number) => ({
  start: `top+=${step * getViewportHeight()} top`,
  end: `+=${getViewportHeight()}`,
});

export const NoneScrollTrigger = ({
  section,
  step,
  triggerElement,
}: ScrollTriggerProps) => {
  gsap.timeline().set(section, { opacity: 1 });
  const range = getStepRange(step);
  return ScrollTrigger.create({
    ...PinnedSectionDefaults,
    trigger: triggerElement,
    start: () => range.start,
    end: () => range.end,
    onLeave: (self) => animation.onLeave({ self, section, step }),
    onLeaveBack: (self) => animation.onLeaveBack({ self, section, step }),
    onEnter: (self) => animation.onEnter({ self, section, step }),
    onEnterBack: (self) => animation.onEnterBack({ self, section, step }),
  });
};
